import { ReactNode } from 'react'
import { StoreProvider } from '../store'

export const withStore = (component: () => ReactNode) => () => {
  return <StoreProvider>{component()}</StoreProvider>
}
